'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import FadeOnChange from '@/components/FadeOnChange';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  initialValue?: string;
  values: Array<string>;
}

type Status = 'initial' | 'running';

function CycleTextOnClick({
  initialValue = '________',
  values,
  onClick,
  ...rest
}: Props) {
  const [currentIndex, setCurrentIndex] = React.useState<number>(-1);
  const [status, setStatus] = React.useState<Status>('initial');

  const ref = React.useRef<HTMLButtonElement>(null);
  const children =
    status === 'initial' ? initialValue : values[currentIndex];

  return (
    <Wrapper
      {...rest}
      ref={ref}
      onClick={(ev) => {
        if (onClick) {
          onClick(ev);
        }

        if (status === 'initial') {
          setStatus('running');
        }

        setCurrentIndex((currentIndex + 1) % values.length);
      }}
    >
      <FadeOnChange changeKey={children}>{children}</FadeOnChange>
    </Wrapper>
  );
}

const Wrapper = styled.button`
  display: inline;
`;

export default React.memo(CycleTextOnClick);
